import Vue from 'vue'
import InfiniteLoading from 'vue-infinite-loading'
import { mapActions, mapState } from 'vuex'
import responseMixin from '@/mixins/responseMixin'
import unreadMessagesBlinkTitleMixin from '@/mixins/unreadMessagesBlinkTitleMixin'
import MyApplicationCard from '@/partials/VacancyCards/MyApplicationCard/MyApplicationCard.vue'

const JOBS_LIMIT = 20

export default Vue.extend<any, any, any, any>({
  mixins: [responseMixin, unreadMessagesBlinkTitleMixin],
  components: {
    MyApplicationCard,
    InfiniteLoading,
  },
  data() {
    return {
      infiniteId: 0,
      totalLoading: false,
    }
  },
  computed: {
    ...mapState('myVacancies', {
      applications: (state: any) => state.freelancerApplied.values,
      isLoading: (state: any) => state.freelancerApplied.isLoading,
      isLoaded: (state: any) => state.freelancerApplied.isLoaded,
      pagination: (state: any) => state.freelancerApplied.pagination,
    }),
  },
  async created() {
    await this.load({ limit: JOBS_LIMIT, offset: 0 })
    this.infiniteId = +new Date()
  },
  methods: {
    ...mapActions({
      load: 'myVacancies/loadFreelancerApplied',
      loadMore: 'myVacancies/loadMoreFreelancerApplied',
    }),
    async onLoadMore($state: any) {
      try {
        if (this.applications.length < this.pagination.total) {
          this.totalLoading = true
          await this.loadMore({ limit: JOBS_LIMIT, offset: this.applications.length })
          return $state.loaded()
        }
        return $state.complete()
      } catch (e) {
        this.parseError(e)
      } finally {
        this.totalLoading = false
      }
    },
  },
  metaInfo() {
    return {
      title: this.getMetaTitle('My Full-time Jobs - Applied'),
    }
  },
})
